import api, {
  setHeaderToken,
  removeHeaderToken
} from '../../../apis/Api';

import router from '@/router'
import { allMixin } from "@/mixins/allMixin.js";

export default {
  namespaced: true,
  state: {
    companyList: {},
  },
  getters: {
    getCompanyList(state) {
      return state.companyList;
    },
  },
  mutations: {
    setCompanyList(state, payload) {
      state.companyList = payload;
    },
  },
  actions: {
    createDCLocation({
      state,
      commit,
      dispatch,
      rootGetters
    }, payload) {
      dispatch('setLoading', true)
      let token = localStorage.getItem("token");
      return new Promise((resolve, reject) => {
        api({
          method: payload.method,
          url: payload.url,
          data: payload.data,
          withCredentials: true,
          headers: {
            'Authorization': 'Bearer ' + token,
          }
        }).then((res) => {
          resolve(res)
          dispatch('setLoading', false)
        }).catch((err) => {
          console.log('authjs=err' + err)
          reject(err);
          dispatch('setLoading', false)
          return false
        })
      })
    },
    getCompanyList({
      state,
      commit,
      dispatch,
      rootGetters
    }, payload) {
      dispatch('setLoading', true)
      let token = localStorage.getItem("token");
      api({
        method: "get",
        url: payload.url,
        params: payload.params,
        headers: {
          'Authorization': 'Bearer ' + token,
        }
      }).then((res) => {
        if (res.respond.status == "success") {
          commit("setCompanyList", res.respond.data);
        } else if (res.respond.status == "forbidden") {
          allMixin.methods.removeSession()
          router.push(`/login`).catch(() => { });
        }
        dispatch('setLoading', false)
      }).catch((err) => {
        console.log('authjs=err' + err)
        dispatch('setLoading', false)
        return false
      })
    },

    setLoading({
      commit
    }, payload) {
      commit("loader/setLoading", payload, {
        root: true,
      });
    },
  },
};